<template>
  <hic-dialog append-to-body :close-on-click-modal="false" :visible="visible" width="70rem" title="治疗标准编码" @close="cancel">
    <el-form :inline="true" :model="staff" :rules="comRules" ref="editor" label-width="5rem" label-position="right" style="padding-right: 3rem">
      <el-row>
        <el-col :span="8">
          <el-form-item label="名称" prop="name">
            <el-input type="text" size="small" placeholder="请输入名称" v-model.trim="staff.name" auto-complete="new-account" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="编码" prop="code">
            <el-input type="text" size="small" placeholder="请输入编码" v-model.trim="staff.code"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="规格" prop="standard">
            <el-input type="text" size="small" placeholder="请输入规格" v-model.trim="staff.standard"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="单价" prop="price">
            <el-input type="text" size="small" placeholder="请输入单价" v-model="staff.price" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="单位" prop="unit">
            <!-- <hic-dict-selector v-model="staff.unit" dict-type="Unit" /> -->
            <el-input type="text" size="small" placeholder="请输入单位" v-model="staff.unit" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="助记符" prop="shortCode">
            <el-input type="text" size="small" placeholder="请输入助记符" v-model="staff.shortCode" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="医保编码" prop="insuranceCode">
            <el-input type="text" size="small" placeholder="请输入医保编码" v-model="staff.insuranceCode" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="费用类别" prop="feeType">
            <hic-dict-selector dict-type="FeeType" v-model="staff.feeType" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="结算类别" prop="settleType">
            <hic-dict-selector dict-type="SettleType" v-model="staff.settleType" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="病案类别" prop="recordType">
            <hic-dict-selector dict-type="RecordType" v-model="staff.recordType" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="统计类别" prop="statisticType">
            <hic-dict-selector dict-type="StatisticType" v-model="staff.statisticType" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性别" prop="gender">
            <hic-dict-selector dict-type="Gender" v-model="staff.gender" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="附加类别" prop="additionType">
            <hic-dict-selector dict-type="AdditionType" v-model="staff.additionType" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="设备类型" prop="equipmentType">
            <hic-dict-selector dict-type="EquipmentType" v-model="staff.equipmentType" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="备注" prop="memo">
            <el-input size="small" type="text" placeholder="请输入备注" v-model="staff.memo" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="医保备注" prop="insuranceMemo">
            <el-input size="small" type="text" placeholder="请输入医保备注" v-model="staff.insuranceMemo" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="说明" prop="desc">
            <el-input size="small" type="text" placeholder="请输入说明" v-model="staff.desc" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="除外" prop="exception">
            <el-input size="small" type="text" placeholder="请输入" v-model="staff.exception" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="国标编码" prop="gbCode">
            <el-input size="small" type="text" placeholder="请输入国标编码" v-model="staff.gbCode" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="是否打印" prop="ifPrint">
            <el-switch v-model="staff.ifPrint"></el-switch>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="停用标志" prop="disabled">
            <el-switch v-model="staff.disabled"></el-switch>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="门诊使用" prop="forOp">
            <el-switch v-model="staff.forOp"></el-switch>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="住院使用" prop="forIp">
            <el-switch v-model="staff.forIp"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">关 闭</el-button>
      <el-button type="primary" @click="save" :disabled="disabledSave">确 定</el-button>
    </div>
  </hic-dialog>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      visible: Boolean,
      staff: Object,
    },
    data() {
      var validateCode = (rule, value, callback) => {
        if (!/^[0-9a-zA-Z_-]*$/.test(value)) {
          return callback(new Error("登录名只能包含：【大小写字母】【数字】【_】【-】"));
        }
        return callback();
      };
      var validateTelephone = (rule, value, callback) => {
        if (value && !/^[0-9]*$/.test(value)) {
          return callback(new Error("电话只能包含：【数字】"));
        }
        return callback();
      };
      return {
        comRules: {
          code: [
            {
              required: true,
              message: "请输入编码",
              trigger: "blur",
            },
          ],
          name: [
            {
              required: true,
              message: "请选名称",
              trigger: "blur",
            },
          ],
          standard: [
            {
              required: true,
              message: "请输入规格",
              trigger: "blur",
            },
          ],
          unit: [
            {
              required: true,
              message: "请输入单位",
              trigger: "blur",
            },
          ],

          price: [
            {
              required: true,
              message: "请输入单价",
              trigger: "blur",
            },
          ],

          shortCode: [
            {
              required: true,
              message: "请输入助记符",
              trigger: "blur",
            },
          ],

          insuranceCode: [
            {
              required: true,
              message: "请输入医保编码",
              trigger: "blur",
            },
          ],

          examineStandardType: [
            {
              required: true,
              message: "请选择检治编码类型",
              trigger: "change",
            },
          ],

          feeType: [
            {
              required: true,
              message: "请选择检治编码类型",
              trigger: "change",
            },
          ],

          settleType: [
            {
              required: true,
              message: "请选择结算类别",
              trigger: "change",
            },
          ],

          recordType: [
            {
              required: true,
              message: "请选择病案类别",
              trigger: "change",
            },
          ],

          statisticType: [
            {
              required: true,
              message: "请选择统计类别",
              trigger: "change",
            },
          ],
        },
        disabledSave: false,
        synDisabledSave: false,
        deptFilterKey: null,
      };
    },
    computed: {
      ...mapGetters(["dict", "user", "dictEnum"]),
      drugRestrict() {
        return this.dict.DrugRestrict.filter((f) => f.code !== "pt");
      },
      depts() {
        let items = [];
        items.push(...this.dict.Dept.filter((d) => !this.deptFilterKey || d.text.indexOf(this.deptFilterKey) > -1 || d.code.indexOf(this.deptFilterKey) > -1 || (d.shortCode && d.short.indexOf(this.deptFilterKey) > -1)));
        items.sort((a, b) => {
          return `${a.codeChain}${a.code}` > `${b.codeChain}${b.code}`;
        });
        return items;
      },
    },

    methods: {
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      save() {
        this.$refs.editor.validate().then((valid) => {
          if (valid) {
            this.disabledSave = true;
            api.Standard.save(this.staff)
              .then((res) => {
                this.$message.success("保存成功!");
                this.$emit("ok");
                this.cancel();
              })
              .catch((err) => {
                this.$message.error(err);
              })
              .finally(() => {
                this.disabledSave = false;
              });
          }
        });
      },
    },
  };
</script>